const parseUTCDate = (date?: string | Date | null): Date | null => {
  if (!date) return null;
  if (date instanceof Date) return date;

  if (typeof date === 'string') {
    if (!date.includes('Z') && !date.includes('+')) {
      const normalized = date.trim().replace(' ', 'T') + 'Z';
      const d = new Date(normalized);
      if (!isNaN(d.getTime())) return d;
    }
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
};

export const dateFormatter = (locale: string, date?: string | Date | null) => {
  const dateObj = parseUTCDate(date);
  if (!dateObj) return '';

  return Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(dateObj);
};

export const formatTimestamp = (locale: string, date?: string | Date | null) => {
  const dateObj = parseUTCDate(date);
  if (!dateObj) return '-';

  return Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(dateObj);
};
